import { render, staticRenderFns } from "./InnovationBlock.vue?vue&type=template&id=6c49edb6&"
import script from "./InnovationBlock.vue?vue&type=script&lang=js&"
export * from "./InnovationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports